import "../../styles/global.scss";
import { Container, Row, Col } from "react-bootstrap";

function PageNotFound({ user }) {
  return (
    <>
      <Container
        fluid
        className={`no-padding no-margin container-fluid d-flex justify-content-center align-items-center`}
        style={{ minHeight: "100vh" }}
      >
        <Row>
          <Col xs={12}>
            <h1>404</h1>
            <p>Oops! The page you're looking for doesn't exist.</p>
            <a href="/">Go Back Home</a>
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default PageNotFound;
